const AMQPConfig = {
  login: 'public',
  passcode: 'public',
  host: 'wtnggmvr'
}

export { AMQPConfig }
